import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../constants/services";
import { ISideSheetData } from "../pages/details/components/sidebarDetail/ISideSheetData";

export const faultCodesApi = createApi({
	reducerPath: "faultCodes",
	baseQuery: dynamicBaseQuery,
	endpoints: (builder) => ({
		sendEmailFaultCodes: builder.mutation<any, any>({
			query: (requestPayload) => ({
				url: "/faultCodes/email",
				method: "POST",
				body: requestPayload,
			}),
		}),
		createTicket: builder.mutation<any, any>({
			query: (requestPayload) => ({
				url: "/faultCodes/createTicket",
				method: "POST",
				body: requestPayload,
				responseHandler: async (response: Response) => {
					const data = await response.json();

					return data;
				},
			}),
		}),
		getFaultCodes: builder.mutation<any, any>({
			query: (requestPayload) => ({
				url: "/faultCodes",
				method: "POST",
				body: requestPayload,
				responseHandler: async (response: Response) => {
					const data = await response.json();

					return data;
				},
			}),
		}),
		getFaultCodesChart: builder.mutation<any, any>({
			query: (requestPayload) => ({
				url: "/faultCodes/topFaults",
				method: "POST",
				body: requestPayload,
				responseHandler: async (response: Response) => {
					const data = await response.json();
					return data;
				},
			}),
		}),
		getFaultCodeDetails: builder.query<ISideSheetData, { faultCodeId: string; lessThan24h?: boolean }>({
			query: ({ faultCodeId, lessThan24h }) => ({
				url: lessThan24h
					? `/faultCodes/${faultCodeId}/details?lessThan24h=true`
					: `/faultCodes/${faultCodeId}/details`,
				method: "GET",
				responseHandler: async (response: Response) => {
					const data = await response.json();
					return data;
				},
			}),
		}),
	}),
});

export const {
	useSendEmailFaultCodesMutation,
	useGetFaultCodesMutation,
	useCreateTicketMutation,
	useGetFaultCodesChartMutation,
	useGetFaultCodeDetailsQuery,
} = faultCodesApi;
